export const CREATE_COST_CODE = 'createCostCode';
export const CREATE_COST_CODES = 'createCostCodes';
export const FETCH_COST_CODE_BY_ID = 'fetchCostCodeById';
export const UPDATE_COST_CODE_BY_ID = 'updateCostCodeById';
export const FETCH_ORGANIZATION_COST_CODES = 'fetchOrganizationCostCodes';
export const DELETE_COST_CODE_BY_ID = 'deleteCostCodeById';
